import { Component }  from '@angular/core';

@Component({
    selector: 'wbm-maintenance',
    template: `
            <img class="stdicon imbl" src="assets/theme/img/sprite.svg#icon__dataserver" alt="">
        <div>Maintenance</div>
    `,
    styles: [':host { background-color: #ececec}'],
})
export class MaintenanceComponent {
}
